import { render, staticRenderFns } from "./account-works.vue?vue&type=template&id=489678f6&"
import script from "./account-works.vue?vue&type=script&lang=js&"
export * from "./account-works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports